import { pick, defaultTo } from 'ramda';

const fallback = defaultTo(() => void 0);

export const CheckboxBlock = {
	functional: true,
	props: {
		name: String,
		value: String,
		label: String,
		checked: Boolean,
		required: Boolean,
		disabled: Boolean,
	},
	render(h, {
		props: {
			name,
			value,
			label,
			checked,
			required,
			disabled,
		},
		data,
		slots,
		listeners
	}) {
		const attrs = pick(['attrs', 'class'], data);
		const change = listeners.change;

		return (
			<label class="checkbox-block" { ...attrs }>
				<input
					class="checkbox-block__input"
					type="checkbox"
					name={ name }
					value={ value }
					checked={ checked }
					onChange={ fallback(change) }
					required={ required }
					domPropsDisabled={ disabled }
				/>
				<svg class="checkbox checkbox-block__checkbox" viewBox="0 0 18 18">
					<rect class="checkbox__indeterminate-check" x="4" y="4" width="10" height="10"/>
					<path class="checkbox__check" d="M13.8912 4.36181C14.3736 3.8794 15.1558 3.8794 15.6382 4.36181C16.1206 4.84422 16.1206 5.62637 15.6382 6.10878L8.22643 13.5205C7.74401 14.003 6.96187 14.003 6.47946 13.5205L2.36181 9.4029C1.8794 8.92048 1.8794 8.13834 2.36181 7.65593C2.84422 7.17351 3.62637 7.17351 4.10878 7.65593L7.35294 10.9001L13.8912 4.36181Z"/>
				</svg>
				{ (label || slots().label) ? (
					<span class="label checkbox-block__label">{ label || slots().label }</span>
				) : null }
				</label>
		)
	}
}
